import produce from 'immer';
import { ActionsUnion, createAction } from 'utils/actionHelpers';

export enum ActionTypes {
  PERFORM_LOGIN = 'PERFORM_LOGIN',
  PERFORM_LOGIN_SUCCESS = 'PERFORM_LOGIN_SUCCESS',
  PERFORM_LOGIN_FAILURE = 'PERFORM_LOGIN_FAILURE',

  IS_LOGINED_REQUEST = 'IS_LOGINED_REQUEST',
  IS_LOGINED = 'IS_LOGINED',

  LOGOUT = 'LOGOUT',
  LOGOUT_SUCCESS = 'LOGOUT_SUCCESS',
  LOGOUT_FAILURE = 'LOGOUT_FAILURE',

  RESTORE_PASSWORD_REQUEST = 'RESTORE_PASSWORD_REQUEST',
  RESTORE_PASSWORD_SUCCESS = 'RESTORE_PASSWORD_SUCCESS',
  RESTORE_PASSWORD_FAILURE = 'RESTORE_PASSWORD_FAILURE',
}

export const initialState = {
  isAuthenticated: false,
  id: undefined,
  roles: undefined,
  account_type_id: undefined,
};

interface IUserData {
  id?: number;
  roles?: { [key: number]: string };
  account_type_id?: number;
  name?: string;
  postal_address?: string;
  demoUser?: boolean;
}

export const Actions = {
  performLogin: (payload: { username: string, password: string }, resetForm: () => void) =>
    createAction(ActionTypes.PERFORM_LOGIN, { values: payload, resetForm }),
  performLoginSuccess: (payload: IUserData) =>
    createAction(ActionTypes.PERFORM_LOGIN_SUCCESS, payload),
  performLoginFailure: () =>
    createAction(ActionTypes.PERFORM_LOGIN_FAILURE),

  loginRequest: () =>
    createAction(ActionTypes.IS_LOGINED_REQUEST),
  loginStatus: (isLogined: boolean, user: IUserData) =>
    createAction(ActionTypes.IS_LOGINED, { isLogined, user }),

  logout: () =>
    createAction(ActionTypes.LOGOUT),
  logoutSuccess: () =>
    createAction(ActionTypes.LOGOUT_SUCCESS),
  logoutFailure: () =>
    createAction(ActionTypes.LOGOUT_FAILURE),

  restorePassword: (payload: { email: string, recaptcha: string }, resetForm: () => void) =>
    createAction(ActionTypes.RESTORE_PASSWORD_REQUEST, { values: payload, resetForm }),
};

export type IUserState = IUserData & {
  isAuthenticated: boolean;
};

export type UserAction = ActionsUnion<typeof Actions>;

export default (state: IUserState = initialState, action: UserAction) =>
  produce(state, (draft: IUserState) => {
    switch (action.type) {
      case ActionTypes.PERFORM_LOGIN_SUCCESS:
        draft.isAuthenticated = true;
        draft.id = action.payload.id;
        draft.name = action.payload.name;
        draft.roles = action.payload.roles;
        draft.account_type_id = action.payload.account_type_id;
        draft.postal_address = action.payload.postal_address;
        draft.demoUser = action.payload.demoUser;
        return;
      case ActionTypes.IS_LOGINED:
        draft.id = action.payload.isLogined ? action.payload.user.id : undefined;
        draft.isAuthenticated = action.payload.isLogined;
        draft.roles = action.payload.isLogined ? action.payload.user.roles : undefined;
        draft.name = action.payload.isLogined ? action.payload.user.name : undefined;
        draft.account_type_id = action.payload.isLogined ? action.payload.user.account_type_id : undefined;
        draft.postal_address = action.payload.isLogined ? action.payload.user.postal_address : undefined;
        draft.demoUser = action.payload.isLogined ? action.payload.user.demoUser : false;
        return;
      case ActionTypes.LOGOUT_SUCCESS:
        draft.id = undefined;
        draft.isAuthenticated = false;
        draft.roles = undefined;
        draft.account_type_id = undefined;
        draft.name = undefined;
        draft.postal_address = undefined;
        return;
    }
  });